//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import nieuwsbrief from '~/components/forms/nieuwsbrief.vue'
export default {
  components: {
    nieuwsbrief
  },
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages,
    }),
  },
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'info-nieuwsbrief')
      ])
  },
  head() {
    return {
      title: this.pages.infonieuwsbrief ? this.pages.infonieuwsbrief.seo.title : 'Nieuwsbrief | Info | Secret Circle',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.infonieuwsbrief ? this.pages.infonieuwsbrief.seo.title : 'Nieuwsbrief | Info | Secret Circle' },
        { hid: 'og:title', name: 'og:title', content: this.pages.infonieuwsbrief ? this.pages.infonieuwsbrief.seo.title : 'Nieuwsbrief | Info | Secret Circle', },
        { hid: 'og:url', name: 'og:url', content: this.$config.feUrl + '/info/nieuwsbrief' },
        { hid: 'og:description', name: 'og:description', content: this.pages.infonieuwsbrief ? this.pages.infonieuwsbrief.seo.description : 'Een beetje discretie is misschien wel wenselijk. We zijn dan ook niet van plan je helemaal suf te mailen, maar als we echt leuk, belangrijk of spannend nieuws hebben, willen we dit graag met je delen.' },
        { hid: 'description', name: 'description', content: this.pages.infonieuwsbrief ? this.pages.infonieuwsbrief.seo.description : 'Een beetje discretie is misschien wel wenselijk. We zijn dan ook niet van plan je helemaal suf te mailen, maar als we echt leuk, belangrijk of spannend nieuws hebben, willen we dit graag met je delen.' },
        { hid: 'keywords', name: 'keywords', content: this.pages.infonieuwsbrief ? this.pages.infonieuwsbrief.seo.keywords : 'Nieuwsbrief, nieuws'},
        ]
    }
  },
}
